export default __webpack_public_path__ + "static/media/open-lock-white.4a341d91.svg";